import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css"; // Import custom styles if needed

const testimonial1 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197963/Ellipse_i8u9iv.png';
const testimonial2 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197961/1_xj9biw.png';
const testimonial3 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197961/2_mc9h9k.png';
const testimonial4 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197962/3_hedjud.png';
const testimonial5 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197963/4_bie8d1.png';
const testimonial6 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197960/5_zg9jca.png';
const testimonial7 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742197960/6_ekrxys.png';

const TestimonialSlider = () => {
  // Slider settings
  const settings = {
    dots: false, // Display dots navigation
    infinite: true, // Infinite loop sliding
    speed: 500,
    slidesToShow: 3, // Number of items to show on Desktop
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000,
    centerMode: true, // Center mode for scaling effect
    centerPadding: "0",
    arrows: true, // Display arrows
    responsive: [
      {
        breakpoint: 1024, // Laptop view
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Tablet view
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Mobile view
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Sample data for slider items

  const items = [
    {
      id: 1,
      imgSrc: testimonial1 || "https://via.placeholder.com/150",
      title: "Harmanjot Singh",
      review: "Dasmesh's Combine Harvester is a game-changer! It’s efficient, saves fuel, and speeds up harvesting. Great customer service and a focus on sustainability make them my top choice.",
    },
    {
      id: 2,
      imgSrc: testimonial2 || "https://via.placeholder.com/150",
      title: "Jivenjot Singh",
      review: "Dasmesh's Combine Harvester has redefined farming for me! Its advanced technology makes harvesting smooth and hassle-free. Plus, the durability and reliability are unmatched. Truly a smart investment!",
    },
    {
      id: 3,
      imgSrc: testimonial3 || "https://via.placeholder.com/150",
      title: "Harnek Singh",
      review: "This harvester saves me hours of labor. It’s incredibly fast and efficient, which means I can complete my harvest in record time. Dasmesh knows exactly what farmers need!",
    },
    {
      id: 4,
      imgSrc: testimonial4 || "https://via.placeholder.com/150",
      title: "Khushpal Deol",
      review: "With Dasmesh, I’ve cut down on fuel costs significantly while increasing productivity. Their machines deliver top performance without burning a hole in my pocket. Highly recommended!",
    },
    {
      id: 5,
      imgSrc: testimonial5 || "https://via.placeholder.com/150",
      title: "Khushpreet Brar",
      review: "I’m amazed by how easy it is to operate the Dasmesh Combine Harvester. It’s intuitive, comfortable, and perfect even for those new to mechanized farming. Great innovation!",
    },
    {
      id: 6,
      imgSrc: testimonial6 || "https://via.placeholder.com/150",
      title: "Japjit Singh",
      review: "Dasmesh doesn’t just sell machines; they provide excellent customer support. Their team ensures everything runs smoothly, making them a trusted partner in my farming journey.",
    },
    {
      id: 7,
      imgSrc: testimonial7 || "https://via.placeholder.com/150",
      title: "Rampal Verma",
      review: "I love Dasmesh's focus on sustainability. The fuel-efficient design not only saves costs but also reduces emissions. It’s a win-win for me and the planet!",
    },
  ];

  return (
    <div className="profile-slider-container" id="testmonail">
      <h3 className="slider-title">WORDS OF TRUST</h3>
      <Slider {...settings}>
        {items.map((item) => (
          <div key={item.id} className="profile-slide">
            {/* Profile Image */}
            <div className="profile-slider-new-sec">
              <div className="profile-image-wrapper">
                <img src={item.imgSrc} alt={item.title} className="profile-image" />
              </div>
              <div className="profile-content">
                <p>{item.review}</p>
                <h3>~{item.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;